module.exports = __webpack_public_path__ + "img/img_pocket_heart.bd9ec8e2.png";